import React, { useState, useEffect } from "react";
import commoncss from "../../../css/common.module.css";
import buttoncss from "../../../css/button.module.css";
import Modal from "../../../elements/Modal";
import InputGroup from "../../../elements/InputGroup";
import { Button } from "../../../elements/Button";
import { ReactComponent as CloseIcon } from "../../../assets/icons/close.svg";

const NewPresetModal = ({
  isOpen,
  onClose,
  onSave,
}) => {
  const [presetName, setPresetName] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setPresetName("");
      setLoading(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSave = async () => {
    const trimmed = presetName.trim();
    if (!trimmed || loading) return;

    if (onSave) {
      setLoading(true);
      try {
        const result = await onSave(trimmed);
        if (result !== false) {
          onClose();
        }
      } catch (error) {
        console.error("Error saving preset:", error);
      } finally {
        setLoading(false);
      }
    } else {
      onClose();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && presetName.trim() && !loading) {
      handleSave();
    }
  };

  return (
    <Modal
      title="New Preset"
      bodycss={commoncss.unsetPadding}
      width="480px"
      headerActions={
        <CloseIcon
          onClick={loading ? undefined : onClose}
          className="clickable"
          style={{ cursor: loading ? "not-allowed" : "pointer", opacity: loading ? 0.6 : 1 }}
        />
      }
      onClose={loading ? () => {} : onClose}
      footerActions={
        <>
          <Button
            btnColor={buttoncss.secondary}
            onClick={onClose}
            disabled={loading}
            label="Cancel"
          />
          <Button
            btnColor={buttoncss.primary}
            label={loading ? "Saving..." : "Create"}
            disabled={!presetName.trim() || loading}
            onClick={handleSave}
          />
        </>
      }
    >
      <div className={commoncss.pd1530} style={{ padding: "24px 30px" }}>
        <InputGroup
          label="Preset Name"
          inputs={[
            <input
              type="text"
              value={presetName}
              onChange={(e) => setPresetName(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Enter Preset Name"
              disabled={loading}
              autoFocus
              style={{
                height: "38px",
                borderRadius: "6px",
                border: "1px solid #DCE5E2",
                padding: "0 12px",
                width: "100%",
                fontSize: "13px",
                color: "#1B3B36",
                outline: "none",
              }}
            />,
          ]}
        />
      </div>
    </Modal>
  );
};

export default NewPresetModal;
